import { z } from "zod";

const widgetTagNameRegex = /^[A-Za-z_-]+$/;

const baseShippingMethod = z.object({
  label: z.string(),
  methodCode: z.string(),
  isDefault: z.boolean().optional(),
  disableForNotAgeVerified: z.boolean().optional(),
  type: z.enum(["atHome", "in-store delivery", "custom delivery"]),
  icon: z.string().url().optional(),
});

const atHomeShippingSchema = baseShippingMethod.extend({
  type: z.literal("atHome"),
});

const inStoreDeliveryShippingSchema = baseShippingMethod
  .extend({
    type: z.literal("in-store delivery"),
    description: z.string(),
    lat: z.number(),
    lon: z.number(),
    defaultZoomLevel: z.number(),
    enableStoreFilteringByAttributes: z.boolean().optional(),
    storeLocatorShopDetailsPage: z.string(),
    filterByCartAvailabilityEnabled: z.boolean().optional(),
    categoryAttributeFilter: z.enum(["flavor_label", "color_label", "all"]).optional(),
    flotiqContentType: z.string(),
    flotiqApiKey: z.string(),
    openingHoursEnabled: z.boolean().optional(),
    openingHoursBreaksEnabled: z.boolean().optional(),
    availableSticksEnabled: z.boolean().optional(),
    availableDevicesEnabled: z.boolean().optional(),
    filtersEnabled: z.boolean().optional(),
    storeCardAddressEnabled: z.boolean().optional(),
  })
  .superRefine((val, ctx) => {
    if (val.filterByCartAvailabilityEnabled && !val.categoryAttributeFilter) {
      ctx.addIssue({
        code: "custom",
        message: "categoryAttributeFilter is required when filterByCartAvailabilityEnabled is true",
        path: ["categoryAttributeFilter"],
      });
    }
  });

const customDeliveryShippingSchema = baseShippingMethod.extend({
  type: z.literal("custom delivery"),
  widgetTagName: z.string().regex(widgetTagNameRegex),
  widgetVariant: z.enum(["embedded", "modal"]),
  description: z.string().optional(),
  widgetUrl: z.url(),
});

export const shippingMethodSchema = z.discriminatedUnion("type", [
  atHomeShippingSchema,
  inStoreDeliveryShippingSchema,
  customDeliveryShippingSchema,
]);
